import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
// The typefaces are served from this origin: the Content Security Policy allows no font host.
import '@fontsource-variable/red-hat-display'
import '@fontsource-variable/red-hat-mono'
import '@fontsource-variable/red-hat-text'

import { App } from './App'
import { dropStaleDrafts } from './annotation/drafts'
import { ErrorBoundary } from './components/ErrorBoundary'
import { installErrorReporter } from './lib/errorReporter'
import { I18nProvider, useI18n } from './lib/i18n'
import './styles.css'

installErrorReporter()
dropStaleDrafts()

function PageFailure({ reference }: { reference?: string }) {
  const { t } = useI18n()
  return <div role="alert" className="alert">
    <p>{t('pageFailed')}</p>
    {reference && <p>{t('errorReference')}: <code>{reference}</code></p>}
    <button onClick={() => window.location.reload()}>{t('reloadPage')}</button>
  </div>
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nProvider>
      <BrowserRouter>
        <ErrorBoundary fallback={(reference) => <PageFailure reference={reference} />}>
          <App />
        </ErrorBoundary>
      </BrowserRouter>
    </I18nProvider>
  </StrictMode>,
)
